var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 3.48893C10.3075 3.29643 8.35333 3.19727 6.405 3.19727C5.25 3.19727 4.095 3.2556 2.94 3.37227L1.75 3.48893",
    stroke: "#5D616F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9585 2.89852L5.08683 2.13435C5.18016 1.58018 5.25016 1.16602 6.236 1.16602H7.76433C8.75016 1.16602 8.826 1.60352 8.9135 2.14018L9.04183 2.89852",
    stroke: "#5D616F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9961 5.33203L10.6169 11.2062C10.5527 12.122 10.5002 12.8337 8.87273 12.8337H5.12773C3.50023 12.8337 3.44773 12.122 3.38356 11.2062L3.00439 5.33203",
    stroke: "#5D616F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02588 9.625H7.96838",
    stroke: "#5D616F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5415 7.29102H8.45817",
    stroke: "#5D616F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashActive);
export default __webpack_public_path__ + "static/media/trash_active.c266423cef14bd8c4c52d470fd072a32.svg";
export { ForwardRef as ReactComponent };